var React = require('react');

function AttentionInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.7362 2.10992C10.4479 1.56492 9.55122 1.56492 9.26289 2.10992L1.76289 16.2766C1.62622 16.5349 1.63455 16.8466 1.78539 17.0958C1.93622 17.3466 2.20705 17.4999 2.49955 17.4999H17.4996C17.7921 17.4999 18.0629 17.3466 18.2129 17.0966C18.3646 16.8466 18.3721 16.5349 18.2354 16.2774L10.7362 2.10992ZM10.8329 14.9999H9.16622V13.3333H10.8329V14.9999ZM9.16622 11.6666V7.49992H10.8329L10.8337 11.6666H9.16622Z","fill":"#EF4B3F"}));
}

AttentionInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = AttentionInline;

AttentionInline.default = AttentionInline;
